import { KASPI } from '@/config'
import AndRuleSpecification from 'kaspi.frontend/src/modules/ruleSpecification/AndRuleSpecification'
import IsAvailableOnBackNavigation from '@/rules/IsAvailableOnBackNavigation'
import IsMobileApp from '@/rules/IsMobileApp'

const { ref } = require("vue");

// Дефолтное поведение кнопки "Назад"
const defaultBackNavigationFunction = () => {
  if ((new AndRuleSpecification(new IsMobileApp(), new IsAvailableOnBackNavigation())).isSatisfiedBy(KASPI.mobapp)) {
    KASPI.mobapp.onBackNavigation()
    return
  }
  window.history.back()
}

// Функция присвоенная этому ref будет вызвана при клике "Назад" в хедере
const backFn = ref(defaultBackNavigationFunction)

// Определяет скрыть или показать кнопку "назад" в хедере
const backBtnIsShown = ref(true)

// Ну думаю понятно, тайтл хедера
const title = ref('')

const transition = ref('slide-left')

export default function useHeader () {

  // Функция для мутирования тайтла
  const setTitle = (val) => {
    title.value = val
  }

  // Функция для того, чтобы сетить кастомную функцию для поведения при клике "Назад"
  const setBackFn = (fn) => {
    backFn.value = fn
  }
  const showBackBtn = () => {
    backBtnIsShown.value = true
  }
  const hideBackBtn = () => {
    backBtnIsShown.value = false
  }
  /**
   *
   * @param transitionName {'slide-right' | 'slide-left'}
   */
  const setTransition = (transitionName) => {
    transition.value = transitionName
  }

  return {
    backFn,
    setBackFn,
    defaultBackNavigationFunction,
    backBtnIsShown,
    hideBackBtn,
    showBackBtn,
    title,
    setTitle,
    transition,
    setTransition
  }
}
